import { request } from '@blade/common';
/**
 *@Description: 任务详情
 */
export const queryDeviceRtspPreviewAddress = (deviceId) => request({
    url: `/api/camera-device-management/api/v1/devices/${deviceId}/rtsp_preview_address`,
    method: 'GET',
});
export const getTaskDetail = (id) => request({
    url: `/api/task-management/api/v1/task/${id}`,
    method: 'GET',
});
export const updateTask = (data) => request({
    url: '/api/task-management/api/v1/task/updateTask',
    method: 'PUT',
    data,
});
// 任务列表更新任务状态
export const updateTaskStatus = (data) => request({
    url: '/api/task-management/api/v1/task/updateTaskStatus',
    method: 'PUT',
    data,
});
export const postTask = (data) => request.post('/api/task-management/api/v1/task/createTask', data);
/**
 *@Description: 根据设备查询区域
 */
export const getDeviceRegion = (deviceId) => request({
    url: `/api/map-management/api/v1/map/device/query/device/detail/${deviceId}`,
    method: 'GET'
});
/**
 *@Description: 获取设备
 */
export const getDeviceTree = () => request.post(`/api/camera-device-management/api/v1/device-groups/devices/tree`, {});
/**
 *@Description: 批量通过设备ID查询区域id
 */
export const getQueryDeviceDetail = (data) => request.post(`/api/map-management/api/v1/map/device/query/batch/device/detail`, data);
export const getAllPortarit = () => {
    return request.post('/api/portrait-management/api/v1/portraitlib/list', {});
};
/**
 *@Description: 批量通过设备ID查询区域id
 */
export const queryDeviceTaskErrorConfigs = (taskId) => {
    return request.get(`/api/task-management/api/v1/task/devices/errorMsg/${taskId}`);
};
/**
 *@deviceIds: 批量通过设备ID查询人体
 */
export const getQueryLablePerson = (data) => {
    return request.post(`/api/task-management/api/v1/task/device/lablePerson/deviceIds`, data);
};
// 区域list
export const getListAllTags = () => request.post('/api/task-management/api/v1/virtual/zone/tag/list/all');
// 删除区域
export const deleteZone = (tagId) => request.delete(`/api/task-management/api/v1/virtual/zone/tag/${tagId}`);
// 创建区域
export const createZone = (data) => request.post('/api/task-management/api/v1/virtual/zone/tag/createTag', data);
// 更新区域
export const updataZone = (data) => request.put('/api/task-management/api/v1/virtual/zone/tag/updateTag', data);
// 查询设备模型
export const getModelType = (data) => request.post('/api/task-management/api/v1/task/task/modelType/deviceId', data);
// 车辆库查询all
export const getVehicleHangar = (data) => request.post('/api/portrait-management/api/v1/automobilelib/library/all', data);
// 人体库 all
export const getAllBodylib = () => {
    return request.post('/api/portrait-management/api/v1/bodylib/list', {});
};
